export default {
  id: '39f3b78122',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=ISUIA><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Back</span></a></div><div class=title>ISUIA</div></div></div><div class=page-content><div class="block block-strong no-hairlines-md margin-top-half"><p><b>International Study of Unruptured Intracranial Aneurysms (ISUIA) 5-year cumulative rupture rates:</b></p><dl><dt>Cavernous carotid artery</dt><dd>&lt;7mm group 1: 0%</dd><dd>&lt;7mm group 2: 0%</dd><dd>7-12mm: 0%</dd><dd>13-24mm: 3.0%</dd><dd>&gt;24mm: 6.4%</dd><dt>AC/MC/IC</dt><dd>&lt;7mm group 1: 0%</dd><dd>&lt;7mm group 2: 1.5%</dd><dd>7-12mm: 2.6%</dd><dd>13-24mm: 14.5%</dd><dd>&gt;24mm: 40%</dd><dt>Post-P Comm</dt><dd>&lt;7mm group 1: 2.5%</dd><dd>&lt;7mm group 2: 3.4%</dd><dd>7-12mm: 14.5%</dd><dd>13-24mm: 18.4%</dd><dd>&gt;24mm: 50%</dd></dl><p>*AC/MC/IC: anterior cerebral/ middle cerebral/ internal carotid (not cavernous)<br>*Post-P Comm: vertebrobasilar, posterior cerebral or communicating arteries</p><p>**group 1: no prior aneurysmal SAH<br>**group 2: prior SAH from an aneurysm elsewhere</p></div></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};